import { useState, useEffect } from 'react'
import useStore from '../../store/store';
import axios from 'axios';
import NavigationMobile from './NavigationMobile';
import ProgramCard from './ProgramCard';

const transformData = async (data) => {
  return Object.entries(data).map(([_key, value]) => {
    const { types, ...rest } = value;

    const transformedTypes = types
      ? Object.values(types).map(({ id, name, lengths = [] }) => ({
        id,
        name,
        lengths,
      }))
      : [];

    return {
      ...rest,
      types: transformedTypes,
    };
  });
};

const ProgramChoiceMobile = () => {
  const { rooms, activeRoom, activeGuest, step } = useStore();
  const [isLoading, setIsLoading] = useState(true);
  const [programs, setPrograms] = useState(new Map([]));
  const [currentRoom, setCurrentRoom] = useState(null);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);

  useEffect(() => {
    setIsBtnDisabled(() => !rooms[activeRoom].people.every(ppl => (!!ppl.program.id && !!ppl.program_type.id && ppl.program_length.length > 0)));
    rooms?.length && setCurrentRoom(() => rooms.find(room => (room.id === activeRoom)));
  }, [activeRoom, rooms])

  useEffect(() => { 
    setIsLoading(true);
  }, [activeRoom])

  useEffect(() => {
    const getPrograms = async (guest_id) => {
      const { data } = await axios.get(
        `https://kivach.ru/calc-new/api_new.php?method=new_programs&guest_id=${guest_id}&room_id=${currentRoom?.apartment}`
      );
      const transformedData = await transformData(data?.res);
      return { guest_id, transformedData };
    };
  
    const fetchAllPrograms = async () => {
      if (!currentRoom || !currentRoom?.people) return;
  
      setIsLoading(true); 
  
      try {
        const allRequests = currentRoom.people.map((ppl) => getPrograms(ppl.guest_id));
        const results = await Promise.all(allRequests);
  
        setPrograms((prev) => {
          const newMap = new Map(prev);
          results.forEach(({ guest_id, transformedData }) => {
            newMap.set(guest_id, transformedData);
          });
          return newMap;
        });
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchAllPrograms();
  }, [activeGuest, currentRoom, currentRoom?.apartment, currentRoom?.people]);
  
  // const checkPeopleProgram = (ppl) => (!!ppl.program.id && !!ppl.program_type.id && ppl.program_length.length > 0);

  const getPrograms = (ppl) => {
   return programs.get(+ppl.guest_id);
  }

  if (currentRoom === null) return null;
  
  return (
    <div className='MobileMain__wrapper'>
      <div className='MobileMain__step roboto-regular'>Шаг {step}/5</div>
      <h2>Выберите программу</h2>

      <div className='ProgramChoiceMobile'>
        <h4>{currentRoom.apartmentName}</h4>

        {isLoading 
          ? <div style={{ flex: '1 1 auto', justifyContent: 'center', alignItems: 'center'}}>
              <span>Загрузка программ</span>
            </div> 
          : currentRoom.people.map(ppl => <ProgramCard key={ppl.name + ppl.id} people={ppl} programs={getPrograms(ppl)} />)}
      </div>

      <NavigationMobile isBtnDisabled={isBtnDisabled} setIsBtnDisabled={setIsBtnDisabled} />
    </div>
  )
}

export default ProgramChoiceMobile